<template>
  <!-- 新建工单 -->
  <div class="rzy-page">
    <div class="form-wrap">
      <el-card>
        <other-device-header-info
          ref="orderHeaderInfo"
          style="margin-top:5px"
        />
      </el-card>
      <div class="rzy-top-bar">
        <el-button @click="goback">取 消</el-button>
        <el-button type="primary" @click="creatWorkOrder">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { otherDeviceHeaderInfo } from "./components";
export default {
  components: {
    otherDeviceHeaderInfo,
  },
  data() {
    return {
      workOrderInfo: {}, // 给编辑工单 临时缓存用。
    };
  },
  methods: {
    // 创建工单
    creatWorkOrder() {
      console.log(111);
      // 判定  工单头部  与  工艺单  是否都填好了
      if (!this.$refs.orderHeaderInfo.getValid()) {
        return;
      }
      const workOrderHeader = this.$refs.orderHeaderInfo.getWorkOrderHeader();
      console.log(workOrderHeader);

      const workOrder = {
        createTime: workOrderHeader.createTime,
        creator: workOrderHeader.creator,
        creatorId: 0,
        depart: workOrderHeader.depart,
        deviceCount: workOrderHeader.deviceCount,
        deviceKind: workOrderHeader.deviceKind,
        deviceName: workOrderHeader.deviceName,
        // deviceNo: "",
        deviceState: 0,
        factoryId: 0,
        id: 0,
        provider: workOrderHeader.provider,
        purchaseDate: workOrderHeader.purchaseDate,
        remark: workOrderHeader.remark,
        unit: workOrderHeader.unit,
        updateTime: 0,
      };

      switch (this.$route.query.type) {
        case 1: // 编辑
          // 工单编辑时候，要注意把id 强制追加进去。
          workOrder.id = this.workOrderInfo.id;
          console.log(this.workOrderInfo);
          //更新请求
          this.$requestBase(
            {
              url: "v1/device/update",
              method: "POST",
              data: workOrder,
            },
            true
          ).then((res) => {
            console.log(res);
            this.$Message.success(res.info);
            this.$router.push("otherDevice");
          });
          break;
        case 0: // 新建
        default:
          this.$requestBase(
            {
              url: "v1/device/create",
              method: "POST",
              data: workOrder,
            },
            true
          ).then((res) => {
            console.log(res);
            this.$Message.success(res.info);
            this.$router.push("otherDevice");
          });
          break;
      }
    },
    goback() {
      this.$router.push("otherDevice");
    },

    // 根据ID，获取工单信息
    getworkOrderInfo(type, workOrderId) {
      this.$requestBase({
        url: "v1/device/detail",
        method: "get",
        params: {
          id: workOrderId,
        },
      }).then((res) => {
        res = res.data;
        this.workOrderInfo = res;
        console.log(this.workOrderInfo);
        this.$refs.orderHeaderInfo.setworkOrderHeader(res, type);
      });
    },

    // 字符串 '2.34512345' 四舍五入成 2位小数=2.35, 再转换成 字符串 '2.35'。注意禁止使用toFixed()。
    // https://wenku.baidu.com/view/a20d74dcadf8941ea76e58fafab069dc50224761.html
    hmjDataChange(inputStr) {
      let data1 = Number(inputStr); // 先转数字
      //Math.round()方法用来把一个数字舍入为最接近的整数
      let data2 = Math.round(data1 * 100) / 100;
      return data2.toString(); //转字符串
    },
  },
  created() {},
  // mounted:html加载完成后执行。执行顺序：子组件-父组件
  mounted() {
    switch (this.$route.query.type) {
      case 1: // 编辑
        this.getworkOrderInfo(
          this.$route.query.type,
          this.$route.query.id
        );
        break;
      case 0: // 新建
      default:
        break;
    }
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.rzy-top-bar {
  margin-top: 20px;
}
.el-input {
  margin: 6px 10px 0px 0px;
  width: 220px;
}

.el-tabs {
  margin: 8px;
}

.footer {
  float: right;
  margin: 0px 10px 10px 0px;
}
</style>
